import { useMemo } from 'react';
import { useLocale } from '../../../utils/date-fns';
import { getDayPeriod } from '../utils';

export function useTimePeriods(): string[] {
    const locale = useLocale();

    return useMemo(
        () => [gettext('DAY'), getDayPeriod(locale, 'evening'), getDayPeriod(locale, 'night')],
        [locale]
    );
}
